import { defineStore } from 'pinia';

import { AuthService } from '@/services';
import { useStateStore } from '@/stores/state.store';
import middlewares from '@/middlewares/http-common';
import router from '@/router';
import { Logger, setSentryUser } from '@/middlewares/sentry.js';

export const useAuthStore = defineStore('coreAuth', {
  state: () => ({
    userToken: localStorage.getItem('userToken') || '',
    isAdmin: false,
  }),
  actions: {
    async trySetupData(clientId) {
      const { getClientId } = useStateStore();

      if (clientId === getClientId && this.userToken !== '') {
        this._setToken(this.userToken);
        // return TODO
      }

      await this._tryGetUserToken(clientId);

      setSentryUser(clientId);
    },
    async refreshToken() {
      const { getClientId } = useStateStore();
      try {
        await this._tryGetUserToken(getClientId);
      } catch (error) {
        throw error;
      }
    },
    async signin(login, password) {
      try {
        const data = await AuthService.signIn(login, password);
        this._setToken(data.token);
        this.isAdmin = data.isAdmin;
        router.push({ name: 'ControlPanel' });
      } catch (error) {
        Logger.error(error);
        this.logout();
        return 'ERR';
      }
      return '';
    },
    async checkAdmin() {
      try {
        middlewares.setHeader('x-access-token', this.userToken);
        const data = await AuthService.checkAdmin();
        this.isAdmin = data.isAdmin;
      } catch (error) {
        Logger.error(error);
        this.logout();
        return false;
      }
      return this.isAdmin;
    },
    async _tryGetUserToken(clientId) {
      try {
        const data = await AuthService.getUserToken(clientId);
        this._setToken(data.token);
      } catch (error) {
        Logger.error(error);
        throw error;
      }
    },
    _setToken(token) {
      this.userToken = token;
      middlewares.setHeader('x-access-token', this.userToken);
      localStorage.setItem('userToken', token);
    },
    logout() {
      this.userToken = '';
      middlewares.setHeader('x-access-token', '');
      localStorage.removeItem('userToken');
    },
  },
  getters: {
    isLoggedIn: (state) => state.userToken !== '',
  },
});
